'use client';

import React from 'react';

// Components
import SkeletonLoader from '@src/components/atoms/skeleton-loader';

const SkeletonListListing = ({ className }) => {
  return (
    <div className='w-full h-full cursor-pointer rounded-top-[16px]'>
      <div className='relative flex items-center justify-center rounded-[16px] mb-[10px] w-full aspect-[1/1]'>
        <SkeletonLoader isShow={true} className={`z-[1] rounded-[16px] ${className}`} />
      </div>
    </div>
  )
}

export default SkeletonListListing